import { Component, Inject, OnInit } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { pqqInitialInfo } from '../pqq-final-form/pqq-final-form.component';
import { ProjectBriefComponent } from '../pqq-sections/project-brief/project-brief.component';
import { environment } from '@/app/environments/environment';
import { DateFormatService } from '@/app/services/date-format.service';
import { MatDialogRef } from '@angular/material/dialog';
import { PrintService } from '@/app/services/shared/print.service';
import { AttachmentListComponent } from "../../../../../../attachment-list/attachment-list.component";


@Component({
  selector: 'app-pre-qualification-questionnaire-view',
  standalone: true,
  imports: [MatRadioModule, CommonModule, ProjectBriefComponent, AttachmentListComponent],
  templateUrl: './pre-qualification-questionnaire-view.component.html',
  styleUrl: './pre-qualification-questionnaire-view.component.css',
})
export class PreQualificationQuestionnaireViewComponent implements OnInit {
  pqqId: number;
  responseId: number;
  initialData: pqqInitialInfo;
  initiatedSelectedWorkPackages = [];
  constructor(
    private projectsService: ProjectsService,
    private dialogRef: MatDialogRef<PreQualificationQuestionnaireViewComponent>,
    public DateFormatService: DateFormatService,
    private printService:PrintService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pqqId = data.pqqId; // Access the pqqId passed from the dialog
    this.responseId = data?.responseId;
    this.initialData = data?.initialData;
    this.initiatedSelectedWorkPackages = data?.initiatedSelectedWorkPackages;
  }

  ngOnInit(): void {
    this.getPreQQ();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  baseUrl = environment.baseUrl;
  pqqData: any;

  getPreQQ() {
    this.projectsService.getPqq(this.pqqId, this.responseId).subscribe({
      next: (data) => {
        this.pqqData = data.data;
        console.log('PQQ data fetched successfully:', data.data);
      },
      error: (error) => {
        console.error('Error fetching PQQ data:', error);
      },
    });
  }
  handlePrint() {
    this.printService.printContent('pqqDeveloperCompanyResponseView', 'pqq-developer-company-response-view');
  }

  
}
